import { Certificate } from '@revenuemarket/bank';
import { Flex, Text, Colors } from '@revenuemarket/cds';
import { RefinedCodefCert } from '~types/codef';
import { checkDuplicateCert } from '~utils/certificate';

// TODO: Refactor to resolve circular dependency
// oxlint-disable-next-line import/no-cycle
import { CertificateRegisterType } from './CertificateSection';
import CertItem from './CertItem';
import EmptyCertificateSection from './EmptyCertificateSection';

const CertListRegisterSection = ({
  setType,
  certificates,
  setSelectedCertificate,
  selectedCertificate,
  registeredCertificates,
  isLoading,
}: {
  setType: (type: CertificateRegisterType) => void;
  certificates: RefinedCodefCert[];
  setSelectedCertificate: (certificate: RefinedCodefCert) => void;
  selectedCertificate?: RefinedCodefCert;
  registeredCertificates: Certificate[];
  isLoading: boolean;
}) => {
  if (isLoading) {
    return (
      <Flex
        align="center"
        justify="center"
        style={{
          height: 128,
        }}
      >
        <Text
          textStyle="14_500"
          style={{
            color: Colors.gray500,
          }}
        >
          조회 중...
        </Text>
      </Flex>
    );
  }
  const filteredCertificates = certificates.filter(
    (cert) => !registeredCertificates.some((regCert) => checkDuplicateCert(regCert, cert)),
  );

  return filteredCertificates.length > 0 ? (
    <Flex direction="column" gap={8}>
      {filteredCertificates.map((certificate) => {
        return (
          <CertItem
            selected={
              selectedCertificate?.certificateOwner === certificate.certificateOwner &&
              selectedCertificate?.certificateAuthority === certificate.certificateAuthority
            }
            key={certificate.certificateOwner + certificate.certificateAuthority}
            item={certificate}
            setSelectedCertificate={setSelectedCertificate}
          />
        );
      })}
    </Flex>
  ) : (
    <EmptyCertificateSection setType={setType} />
  );
};

export default CertListRegisterSection;
